import React, { useState, useEffect, useRef } from 'react';

const LazyImage = ({ src, alt, className }) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [isInView, setIsInView] = useState(false);
  const imgRef = useRef();

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsInView(true);
          observer.disconnect();
        }
      },
      { rootMargin: '50px' }
    );

    if (imgRef.current) {
      observer.observe(imgRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <div ref={imgRef} className={className}>
      {isInView && (
        <img
          src={src}
          alt={alt}
          className={className}
          onLoad={() => setIsLoaded(true)}
          style={{ 
            opacity: isLoaded ? 1 : 0, 
            transition: 'opacity 0.3s ease-in-out' 
          }}
          loading="lazy"
        />
      )}
      {!isInView && (
        <div 
          className={`${className} bg-gray-200 animate-pulse flex items-center justify-center`}
          style={{ minHeight: '200px' }}
        >
          <span className="text-gray-400">Loading...</span>
        </div>
      )}
    </div>
  );
};

export default LazyImage;
